import { pushFbqEvent } from '@/utils/fbqTrack'
import { useFbRuntimeConfig } from '@/composables/fbq/useFbRuntimeConfig'

const lastReportTimes = new Map<string, number>()
const DEDUP_WINDOW_MS = 5000

export function useFbqAddToCart() {
  const { isEventEnabled } = useFbRuntimeConfig()

  function reportAddToCart(
    productId: string | number,
    productName: string,
    price: string | number,
  ) {
    const key = String(productId)
    const now = Date.now()
    if (lastReportTimes.has(key) && now - lastReportTimes.get(key)! < DEDUP_WINDOW_MS)
      return
    lastReportTimes.set(key, now)

    const serverCode = isEventEnabled('ADD_TO_CART') ? 'fb_add_to_cart' : undefined
    pushFbqEvent('AddToCart', {
      product_id: key,
      product_name: productName,
      price_usd: String(price),
      currency: 'USD',
    }, serverCode)
  }

  return { reportAddToCart }
}
